import { Typography } from '@mui/material';

export const TextError = ({ errorText }: { errorText: string }) => {
  return (
    <Typography color="red" fontSize={'16px'} fontWeight="normal">
      {errorText}
    </Typography>
  );
};
